var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon2DShapes = function SvgIcon2DShapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_2d_shapes_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.83 13H3.17c-.814 0-1.542-.42-1.949-1.125a2.227 2.227 0 0 1 0-2.25l4.33-7.5A2.226 2.226 0 0 1 7.5 1c.813 0 1.542.42 1.949 1.125l4.33 7.5a2.227 2.227 0 0 1 0 2.25A2.228 2.228 0 0 1 11.83 13ZM7.5 2.5a.735.735 0 0 0-.65.375l-4.33 7.5a.736.736 0 0 0 0 .75.737.737 0 0 0 .65.375h8.66c.391 0 .585-.262.65-.375a.736.736 0 0 0 0-.75l-4.33-7.5A.737.737 0 0 0 7.5 2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.294 18.93-.133-.001a6.681 6.681 0 0 1-5.68-3.408.75.75 0 0 1 1.309-.733 5.173 5.173 0 0 0 4.4 2.64c1.36.04 2.68-.483 3.672-1.437a5.121 5.121 0 0 0 1.579-3.614 5.138 5.138 0 0 0-3.093-4.824.75.75 0 0 1 .6-1.375 6.636 6.636 0 0 1 3.993 6.228 6.613 6.613 0 0 1-2.04 4.666 6.607 6.607 0 0 1-4.607 1.858Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_2d_shapes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
export default SvgIcon2DShapes;